import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'hb-text-subtitle',
  templateUrl: './text-subtitle.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextSubtitleComponent {
  @Input() text: string;
  @Input() icon: string = null;
}
